import { FC } from "react";
import { ContentfulCategoryEntry } from "../lib/contentfulTypes";
import useStorefrontApi from "../hooks/useStorefrontApi";

interface CategoryWrapperProps {
  category: ContentfulCategoryEntry;
  Component: any; // TODO
  slideBackground?: string;
  slideHoverBackground?: string;
}

export interface FormattedCategory {
  ctaText: string;
  description?: string;
  hoverImageUrl?: string;
  imageUrl?: string;
  mobileImageUrl?: string;
  onHover?: (hover: boolean) => void;
  productCount?: string;
  title: string;
  url: string;
}

const shopifyQuery = (shopifyCollectionId: string) => `
  query {
    collection(id: "${shopifyCollectionId}") {
      title
      description
      handle
      image {
        url
      }
      products(first: 250) {
        edges {
          node {
            id
          }
        }
        pageInfo {
          hasNextPage
        }
      }
    }
  }
`;

const CategoryWrapper: FC<CategoryWrapperProps> = ({
  Component,
  category: {
    fields: {
      ctaText,
      description,
      hoverAsset,
      imageAsset,
      mobileImageAsset,
      productCount,
      relativeUrl,
      shopifyCollection,
      title,
      transparentProductImage,
    }
  },
  slideBackground,
  slideHoverBackground
}) => {
  let imageUrl = (imageAsset?.fields?.file) ? `https:${imageAsset.fields.file.url}` : '';
  let mobileImageUrl = mobileImageAsset?.fields?.file ? `https:${mobileImageAsset.fields.file.url}` : '';
  let hoverImageUrl = (hoverAsset?.fields?.file) ? `https:${hoverAsset.fields.file.url}` : '';

  if (!shopifyCollection) {
    return (
      <Component
        ctaText={ctaText}
        description={description}
        productCount={productCount}
        hoverImageUrl={hoverImageUrl}
        imageUrl={imageUrl}
        mobileImageUrl={mobileImageUrl}
        onHover={() => {}}
        slideBackground={slideBackground}
        slideHoverBackground={slideHoverBackground}
        title={title}
        transparentProductImage={!!transparentProductImage}
        url={relativeUrl}
      />
    );
  }

  const query = shopifyQuery(shopifyCollection);
  const { storefrontData } = useStorefrontApi(query);

  // If no collection returns from this query, it is not
  // configured on this store, and should not be rendered.
  // @ts-ignore
  const shopifyData = storefrontData?.collection;

  if (!shopifyData && !title && !description && !relativeUrl && !imageUrl && !hoverImageUrl) {
    return null;
  }

  const productEdges = shopifyData?.products?.edges || [];
  const hasNextPage = shopifyData?.products?.pageInfo?.hasNextPage || false;
  // Determine product count
  const displayedProductCount = hasNextPage ? '250+' : productEdges.length;

  // Prefer overrides if they exist, fall back to collection data.
  return (
    <Component 
      ctaText={ctaText}
      // @ts-ignore
      description={description || shopifyData?.description}
      hoverImageUrl={hoverImageUrl}
      imageUrl={imageUrl || shopifyData?.image?.url}
      mobileImageUrl={mobileImageUrl}
      onHover={() => {}}
      productCount={productCount || displayedProductCount}
      slideBackground={slideBackground}
      slideHoverBackground={slideHoverBackground}
      // @ts-ignore
      title={title || shopifyData?.title}
      transparentProductImage={!!transparentProductImage}
      // @ts-ignore
      url={relativeUrl || (shopifyData ? `/collections/${shopifyData.handle}` : '')}
    />
  );
}

export default CategoryWrapper;